import {
  ReviewStickyWidgetV2,
  useReviewContext,
} from '@reconvert/review-collector-ui';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { redirect } from '../../utils/reviewModalRedireact';
import { getUserReviewEligblity } from '../../services/review.service';
import { selectAppState } from '../../app/slice/appSlice';
import { useAppSelector } from '../../app/hooks';
import { useMediaQuery } from '@chakra-ui/react';

const ReviewStickyCollectorV2 = () => {
  const { isVisible, showThanksForWidget } = useReviewContext();
  const [isEligible, setIsEligible] = useState(false);
  const { platformStoreId } = useAppSelector(selectAppState);
  const WIDGET_NAME = "FLOW_BUILDER";
  const { t } = useTranslation();
  const isMobileView = useMediaQuery('(max-width: 768px)')[0];

  useEffect(() => {
    const fetchUserReviewEligblity = async () => {
      try {
        const response = await getUserReviewEligblity(platformStoreId);

        setIsEligible(response.eligible);
      } catch (error) {
        console.log("error", error)
      }
    }

    fetchUserReviewEligblity();
  }, [platformStoreId]);

  return (
    <>
      {(isEligible && (isVisible || showThanksForWidget === WIDGET_NAME)) &&
        <div
          style={{
            position: 'fixed',
            zIndex: '99',
            bottom: '30px',
            right: 'calc((100vw - 700px) / 2)',
            left: 'calc((100vw - 700px) / 2)',
            justifyContent: 'center',
            display: 'flex',
          }}
        >
          <ReviewStickyWidgetV2
            description={t('How would you rate your experience so far?')}
            widgetName={WIDGET_NAME}
            page={"flow builder"}
            redirect={redirect}
            closeButton={t("Not now")}
            alignStartComponent={true}
            isMobileView={isMobileView}
          />
        </div>
      }
    </>
  );
};

export default ReviewStickyCollectorV2;
